import SubSystemType from 'SubSystemType';
import BaseServiceRequestIIS from 'BaseServiceRequestIIS';

class GetStockPriceAndInfoRequest extends BaseServiceRequestIIS {
    constructor() {
        super();
    }

    getServiceMethod() {
        return "FindInstrument_Web";
    }
    getSubSystem() {
        return SubSystemType.GRAPH;
    }

    getMessageName() {
        return 'StockInformation';
    }
}

export default GetStockPriceAndInfoRequest;